import axios from 'axios'
import { message, Modal, notification } from 'ant-design-vue'
import store from '../store'
import db from './localstorage'

// eslint-disable-next-line no-undef
const constURL = GlobUrl.baseURL
// 统一配置
const JIEBAO_REQUEST = axios.create({
  baseURL: constURL,
  responseType: 'json',
  validateStatus (status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})
axios.defaults.withCredentials = false
axios.defaults.crossDomain = true
// 401防止重复弹窗
let unLogin = false
// 上传文件头部路径
// 拦截请求
JIEBAO_REQUEST.interceptors.request.use((config) => {
  // let expireTime = store.state.account.expireTime
  // let now = moment().format('YYYYMMDDHHmmss')
  // 让token早10秒种过期，提升“请重新登录”弹窗体验
  // if (now - expireTime >= -10) {
  //   Modal.error({
  //     title: '登录已过期',
  //     content: '很抱歉，登录已过期，请重新登录',
  //     okText: '重新登录',
  //     mask: false,
  //     onOk: () => {
  //       return new Promise((resolve, reject) => {
  //         db.clear()
  //         location.reload()
  //       })
  //     }
  //   })
  // }
  // 有 token就带上
  if (store.state.account.token) {
    config.headers.Authentication = store.state.account.token
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// 拦截响应
JIEBAO_REQUEST.interceptors.response.use((config) => {
  return config
}, (error) => {
  if (error.response) {
    const errorMessage = error.response.data === null ? '系统内部异常，请联系网站管理员' : error.response.data.message
    switch (error.response.status) {
      case 404:
        notification.error({
          message: '系统提示',
          description: '很抱歉，资源未找到',
          duration: 4
        })
        break
      case 403:
        notification.error({
          message: '系统提示',
          description: '很抱歉，您无法访问系统资源，可能是因为没有相应权限。',
          duration: 4
        })
        break
      case 401:
        if (!unLogin) {
          // 若是钉钉登录-无感刷新token
          if (db.get('USER_TYPE') === 2) {
            console.log('钉钉登录-刷新token')
            axios({
              method: 'get',
              url: constURL + '/reGetToken',
              headers: {
                'Content-Type': 'multipart/form-data',
                'Authentication': store.state.account.token
              },
              params: { dingUserid: db.get('USER').dingUserid }
            }).then((res) => {
              // 获取新token 替换vuex和浏览器缓存内数据
              store.commit('account/setToken', res.data.data.token)
              window.location.reload()
            })
            break
          }
          notification.warn({
            message: '系统提示',
            description: '很抱歉，您无法访问系统资源，可能是因为没有相应权限或者登录已失效',
            duration: 4
          })
          let secondsToGo = 5
          const modal = Modal.error({
            title: '系统提示',
            content: `很抱歉，您无法访问系统资源，可能是因为没有相应权限或者登录已失效, 将在 ${secondsToGo} 秒后自动跳转登录页面.`,
            okText: '重新登录',
            mask: false,
            onOk: () => {
              return new Promise((resolve, reject) => {
                db.clear()
                location.reload()
              })
            }
          })
          const interval = setInterval(() => {
            secondsToGo -= 1
            modal.update({
              content: `很抱歉，您无法访问系统资源，可能是因为没有相应权限或者登录已失效, 将在 ${secondsToGo} 秒后自动跳转登录页面.`
            })
          }, 1000)
          setTimeout(() => {
            clearInterval(interval)
            modal.destroy()
            return new Promise((resolve, reject) => {
              db.clear()
              location.reload()
            })
          }, secondsToGo * 1000)
          unLogin = true
        }
        break
      default:
        notification.error({
          message: '系统提示',
          description: errorMessage,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
})

const request = {
  constURL: constURL,
  post (url, params) {
    return JIEBAO_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  postJson (url, params) {
    return JIEBAO_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params)
      }],
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  put (url, params) {
    return JIEBAO_REQUEST.put(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  putJson (url, params) {
    return JIEBAO_REQUEST.put(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params)
      }],
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  get (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && params[key] !== '') {
          _params += `${key}=${encodeURIComponent(params[key])}&`
        }
      }
    }
    return JIEBAO_REQUEST.get(`${url}${_params}`)
  },
  delete (url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return JIEBAO_REQUEST.delete(`${url}${_params}`)
  },
  export (url, params = {}) {
    message.loading('导出数据中')
    return JIEBAO_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      const fileName = `${new Date().getTime()}_导出结果.xlsx`
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
    }).catch((r) => {
      console.error(r)
      message.error('导出失败')
    })
  },
  DocExport (url, params = {}) {
    message.loading('导出数据中')
    return JIEBAO_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      const fileName = `${new Date().getTime()}_导出结果.docx`
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, fileName)
      }
    }).catch((r) => {
      console.error(r)
      message.error('导出失败')
    })
  },
  download (url, params, filename) {
    message.loading('文件传输中')
    return JIEBAO_REQUEST.post(url, params, {
      transformRequest: [(params) => {
        let result = ''
        Object.keys(params).forEach((key) => {
          if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
            result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
          }
        })
        return result
      }],
      responseType: 'blob'
    }).then((r) => {
      const content = r.data
      const blob = new Blob([content])
      if ('download' in document.createElement('a')) {
        const elink = document.createElement('a')
        elink.download = filename
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else {
        navigator.msSaveBlob(blob, filename)
      }
    }).catch((r) => {
      console.error(r)
      message.error('下载失败')
    })
  },
  upload (url, params) {
    return JIEBAO_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js